/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamLoadShiftEntrySchema = z.object({
  estimateDeltaHours: z.number().nullish(),
  estimateDeltaWorkdays: z.number().nullish(),
  itemsAdded: z.int(),
  itemsRemoved: z.int(),
  teamId: z.int(),
  teamName: z.string().nullish(),
});
